import { state, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var Breadcrum = [
    {
        name: "Producto",
        key: "producto",
        ariaCurrent: "",
    },
    {
        name: "Plan",
        key: "plan",
        ariaCurrent: "",
    },
    {
        name: "Validar cliente",
        key: "cliente",
        ariaCurrent: "",
    },
    {
        name: "Cofirmación cliente",
        key: "confirmacion",
        ariaCurrent: "",
    },
    {
        name: "Pago",
        key: "pago",
        ariaCurrent: "",
    },
    {
        name: "Cofirmación pago",
        key: "confirmacion",
        ariaCurrent: "",
    },
];
export var stepProgress = [
    {
        id: "1",
        name: "Nombre del producto",
        state: state.complete,
    },
    {
        id: "2",
        name: "Tipo de plan",
        state: state.complete,
    },
    {
        id: "3",
        name: "Datos del cliente",
        state: state.complete,
    },
    {
        id: "4",
        name: "Confirmación",
        state: state.complete,
    },
    {
        id: "5",
        name: "Datos de pago",
        state: state.complete,
    },
    {
        id: "6",
        name: "Confirmación de pago",
        state: state.complete,
    },
];
export var getDataFormFilters = function (dataForm) {
    var _a;
    return [
        {
            label: "Datos personales",
            type: "subtitle",
        },
        {
            label: "".concat(dataForm === null || dataForm === void 0 ? void 0 : dataForm.Name),
            name: "Nombre",
            type: "label",
        },
        {
            label: "".concat(dataForm.LastNames),
            name: "Apellidos",
            type: "label",
        },
        {
            label: "".concat((_a = dataForm.DocumentNumber) === null || _a === void 0 ? void 0 : _a.replace(/(\d{3})(\d{7})(\d{1})/, "$1-$2-$3")),
            name: "No. de documento",
            type: "label",
        },
        {
            label: "Datos de seguro",
            type: "subtitle",
        },
        {
            label: "".concat(dataForm.Insurance),
            name: "Producto",
            type: "label",
        },
        {
            label: "".concat(dataForm.PlanTypeName),
            name: "Plan",
            type: "label",
        },
        {
            label: "".concat(dataForm.CampaignName),
            name: "Campaña",
            type: "label",
        },
        {
            label: "".concat(dataForm.CoverType),
            name: "Tipo de cobertura",
            type: "label",
        },
        {
            label: "".concat(dataForm.PaymentMode),
            name: "Modalidad de pago",
            type: "label",
        },
        {
            label: "".concat(dataForm.Currency),
            name: "Moneda",
            type: "label",
        },
        {
            label: "".concat(dataForm.Prima),
            name: "Prima",
            type: "label",
        },
    ];
};
